import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import RowThreeText from './RowThreeText'

class Timeline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    })
  }
  returnTitle(title) {
    if (title.style && title.style.size === 'small') {
      return <div className="grid-section-data" style={{marginBottom: '20px'}}>{title.content}</div>
    } else {
      return <h3 className="grid-section-data">{title.content}</h3>
    }
  }
  returnSubTitle(sub) {
    let className
    if (sub.style && !sub.style.bold) {
      className = 'grid-section-text'
    }

    let content = sub.content
    if (sub.style && sub.style.emphasis) {
      content = content.split(':')
      content[0] = <span className="sectra-light">{content[0]}:</span>
    }

    return <h3 className={className}>{content}</h3>
  }
  render() {
    let data
    if (this.state && this.state.data) {
      data = this.state.data
    }

    const that = this

    return (
      <div>
        <RowThreeText data={data && data.title} />

        <section className="main-grid center" id="timeline">
          <ul className="grid group">


            {
              data && data.content.map((el, i) => {
                let className = (i === 1) ? 'grid-small grid-middle group' : 'grid-small group'
                return (
                  <li className={className} key={i}>
                    {
                      el.map((subEl, j) => {
                        let shift = subEl.year ? {marginLeft: '32px'} : {}
                        return (
                          <div className="grid-mini inner-right-large" key={j}>
                            <h6 className="grid-section-title">
                              {
                                subEl.year ? <b className="grid-section-data data-yy">{subEl.year}</b> : ''
                              }
                              <span style={shift}>{subEl.date}</span>
                            </h6>
                            <div className="grid-section-body">
                              <b className="grid-section-data">{subEl.title}</b>
                              <p>{subEl.subTitle}</p>
                            </div>
                          </div>
                        )
                      })
                    }
                  </li>
                )
              })
            }
          </ul>

          <ul className="grid group" style={{marginTop: '100px'}}>
            {
              data && data.contentLarge.map((el, i) => {
                const mid = [1, 4, 7, 10, 13, 16]
                const className = (mid.includes(i)) ? 'grid-small grid-middle' : 'grid-small'
                return (
                  <li className={className} key={i} style={{minHeight: '350px'}}>
                    <h6 className="grid-section-title">{el.date}</h6>
                    {
                      el.content.map((subEl, j) => {

                        const title = that.returnTitle(subEl.title)
                        const subTitle = that.returnSubTitle(subEl.subTitle)

                        return (
                          <div className="grid-section-body" style={{marginBottom: '15px'}} key={j}>
                            {title}
                            {subTitle}
                          </div>
                        )
                      })
                    }
                  </li>
                )
              })
            }
          </ul>
        </section>
      </div>
    )
  }
}
Timeline.contextTypes = {
}
Timeline.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
    //data: state.token.data
  }
}

export default connect(mapStateToProps)(Timeline)



// WEBPACK FOOTER //
// ./src/components/Utils/Timeline.js